import type { EscrowRelockerSDK } from "@marinade.finance/escrow-relocker-sdk/src";
import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { useWalletInfo } from "contexts/WalletInfoContext";
import type { NFTType } from "services/domain/nftType";
import { fetchGovernanceData } from "services/marinade/fetchGovernanceData";

import { useEscrow } from "./useEscrow";

const useGovernance = () => {
  const { walletAddress } = useWalletInfo();

  const sdk = useEscrow();
  return useQuery(
    ["nfts"],
    () => {
      return fetchGovernanceData(sdk as EscrowRelockerSDK);
    },
    { enabled: !!walletAddress, refetchOnWindowFocus: false }
  ) as UseQueryResult<
    { nfts: NFTType[]; lockedMnde: number; votingPower: number },
    Error
  >;
};

export default useGovernance;
